import { useLayoutEffect } from 'react'
import { useAppSelector } from 'reduxTyped'

import { getIsUserFlagEnabled, getUserId } from 'common/core/selectors/appSelectors'
import { useUsercentrics } from 'utils/commonHooks'
import { UserFlag } from 'utils/services/featureFlagsService/constants'

import { engagementService } from './brazeEngagementService'

const USERCENTRICS_BRAZE_NAME = 'Braze'

export const useEngagementService = () => {
  const { usercentricsServicesInfo } = useUsercentrics(USERCENTRICS_BRAZE_NAME)
  const isBrazeProvided = usercentricsServicesInfo[USERCENTRICS_BRAZE_NAME]?.status ?? false
  const isBrazeExperimentEnabled = useAppSelector((state) =>
    getIsUserFlagEnabled(state, UserFlag.ENABLE_BRAZE),
  )
  const userId = useAppSelector(getUserId)

  useLayoutEffect(() => {
    if (!isBrazeProvided || !isBrazeExperimentEnabled || !userId) {
      engagementService.dispose()
      return
    }

    engagementService.init(userId)
  }, [isBrazeProvided, isBrazeExperimentEnabled, userId])

  return engagementService
}
